const strings = {
  labels: {
    noResults: 'No results found',
    suggestedAddressHeader: 'Suggested Address',
    enterAddressManuallyButton: 'Enter Address Manually',
  },
} as const;

export default strings;
